import React, { useState } from "react";
import { toast } from "react-toastify";

interface CopyIconProps {
  text?: string;
  className?: string;
}

const CopyIcon: React.FC<CopyIconProps> = ({ text, className = "" }) => {
  const [copied, setCopied] = useState<boolean>(false);

  const handleCopy = (e: React.MouseEvent) => {
    e.preventDefault();
    if (!text) return;

    // Use a temporary textarea to copy if navigator.clipboard is not available
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(() => {
        onSuccess();
      }).catch(err => {
        console.error('Failed to copy: ', err);
        fallbackCopyTextToClipboard(text);
      });
    } else {
      fallbackCopyTextToClipboard(text);
    }
  };

  const fallbackCopyTextToClipboard = (text: string) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    
    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      if (successful) {
        onSuccess();
      }
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
  };

  const onSuccess = () => {
    setCopied(true);
    toast.success("Copied to clipboard!", {
      autoClose: 1000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
    });
    setTimeout(() => setCopied(false), 2000);
  };

  if (!text) return null;

  return (
    <i
      className={`mdi ${copied ? "mdi-check text-success" : "mdi-content-copy"} copy-icon-style ${className}`}
      onClick={handleCopy}
      title="Copy to clipboard"
      style={{ cursor: "pointer", fontSize: "16px" }}
    />
  );
};

export default CopyIcon;
